module.exports = __webpack_public_path__ + "media/img/careers/why-work/why-work-photo3-58fdbe2327428fad87fc16e1e09b0773.jpg";